import _styled, { default as _styled2, default as _styled3 } from "styled-components";
import { getThemeStyle } from "~/features/ui/get-theme-style";
type Props = {
  children: React.ReactNode;
};
export function DownloadsTables(props: Props) {
  const {
    children
  } = props;
  const themeStyle = getThemeStyle({
    mode: "light"
  });
  return <_StyledDiv $_css={[{
    "@media (min-width: 1024px)": {
      "paddingLeft": "4rem",
      "paddingRight": "4rem"
    }
  }, themeStyle.background, themeStyle.border]}>
      <_StyledDiv2 $_css2={[{
      "@media (min-width: 1024px)": {
        "borderLeftWidth": "1px",
        "borderRightWidth": "1px"
      }
    }, themeStyle.border]}>{children}</_StyledDiv2>
      {/* Baked-in bottom spacing matches the height of a standard `spacer`
          pageBuilder section — saves editors from having to insert one
          between the downloads block and whatever comes below it. */}
      <_StyledDiv3 />
    </_StyledDiv>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-sf-1o7tysq-0"
})`${p => p.$_css}`;
var _StyledDiv2 = _styled2("div").withConfig({
  componentId: "sc-sf-1o7tysq-1"
})`${p => p.$_css2}`;
var _StyledDiv3 = /*#__PURE__*/_styled3("div").withConfig({
  displayName: "downloads-tables___StyledDiv3",
  componentId: "sc-l8fhag-0"
})({
  "height": "var(--spacing-3xl)"
});